@if(materiel){
<div tuiCardLarge tuiSurface="flat">
    <h3>
        {{ materiel.libelle }}
    </h3>
    @if(photoUrl0()){
    <img [src]="photoUrl0()" [alt]="'Photo de '+materiel.libelle">
    }
</div>}
@else {
<div tuiCardLarge tuiSurface="flat">
    <h3 class="placeholder">XXXXX XXXXXXX XXX
    </h3>
</div>
}